


















import { Component } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { dateTimeSeconds, dateTime, cpf } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import ComboStatus from "../promocoes/ComboStatus.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import WysiwygEditor from "@/shared/components/wysiwyg-editor.vue";
import AlterarPromocaoForm from "./AlterarPromocaoForm.vue";
import PremiosPromocao from "./PremiosPromocao.vue";

@Component({
  components: {
    DataTable,
    Tooltip,
    ComboStatus,
    DatePicker,
    WysiwygEditor,
    AlterarPromocaoForm,
    PremiosPromocao,
  },
  filters: { dateTimeSeconds, cpf, dateTime },
})
export default class AlterarPromocao extends mixins(GlobalMixin) {
  idPromocao: number | null = null;
  loading = false;
  selectRow = true;
  tipo: string | null = null;

  mounted() {
    if (this.$route.params.idPromocao) {
      this.idPromocao = +this.$route.params.idPromocao;
    }
  }

  voltar() {
    this.$router.push({
      name: "promocoes",
    });
  }
}
